<template>
  <div id="app">
    <router-view></router-view>
  </div>
</template>

<script>


export default {
  name: 'App',
  components: {}
}
</script>

<style>

* {
  margin: 0;
  padding: 0;
  list-style: none;
  text-decoration: none;

}


body {
  width: 100%;

}

</style>
